/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, EffectCallback } from 'react';

// import { isDev } from '../../common';
// import { isFunction } from '../../typeguards';
import useLatest from './useLatest';
/**
 * Executes a callback on component unmount
 * @example
 * ```ts
 *  useUnmount(() => {
 *    console.log("useUnmount")
 * })
 * ```
 */
function useUnmount(callback: EffectCallback) {
  // if (isDev) {
  //   if (!isFunction(callback)) {
  //     console.error(`useUnmount expected parameter is a function, got ${typeof callback}`);
  //   }
  // }

  /**
   * caused by the closure mechanism in useEffect,
   * because the function passed in when the component is unloaded for the first rendering,
   * in order to get the real-time state, we need to use useRef to achieve it.
   */
  const callbackRef = useLatest(callback);

  useEffect(() => {
    return () => {
      callbackRef.current();
    };
  }, []);
}

export default useUnmount;
